(ns app.components.tables.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))
(defclass table-style
  [] {:border-collapse "separate"
      :border-radius "6px"
      :border-spacing "0 15px"
      :background-color :theme/*surface98*}
  [:.MuiTable-root  {}])

(defclass table-body-style
  [] {}
  [:.MuiTableBody-root  {}])

(defclass table-cell-style
  [] {:border-bottom "none"}
  [:&:first-child {:border-top-left-radius "6px"
                   :border-bottom-left-radius "6px"}]
  [:&:last-child {:border-top-right-radius "6px"
                  :border-bottom-right-radius "6px"}])


(defclass table-head-style
  [] {:align-items "center"
      :justify-content "center"}
  [:.MuiTableCell-head {:background-color :theme/*surface98*
                        :margin-bottom "40px"
                        :line-height "0px"
                        :border-bottom "2px solid" 
                        :border-color :theme/*greyBorderColor*}])

(defclass table-wrapper-style
  [] {:overflow "auto"
      :box-shadow "none"})

(defclass table-row-style
  [] {:align-items "center"
      :background "white"
      :border-radius "6px"
      :cursor "pointer"
      }
  [:.MuiTableRow-root {:background-color :theme/*surface98*
                       :padding-bottom "40px"
                       :border "1px solid gray"}]
  [:&:hover
   {:box-shadow "0 4px 8px 0 rgba(0, 0, 0, 0.2)"}]
  )


(defclass table-header-1-style
  [] {:width "40%"
      :align-items "center"
      :font-size "20px"
      :font-weight "700"})

(defclass close-icon-span-style
  [] {:position "relative"
      :left "-20px"
      :box-sizing "border-box"
      :-webkit-tap-highlight-color "transparent"
      :background-color "transparent"
      :outline 0
      :border 0
      :margin 0
      :border-radius 0
      :padding 0
      :user-select "none"
      :vertical-align "middle"
      :-webkit-appearance "none"
      :text-decoration "none"
      :color "inherit"
      :cursor "pointer"
      :display "inline-flex"
      :-webkit-box-pack "start"
      :justify-content "flex-start"
      :-webkit-box-align "center"
      :align-items "center"})

(defclass product-form-name-component
  [] {:font-size "14px"
  })